
export const HTTP_HEADERS = {
    ACCEPT_LANGUAGE: 'accept-language',
    Authorization: 'authorization',
    Etag: 'etag',
    X_CURSOR: 'x-cursor',
    X_FOUND: 'x-found',
    X_MESSAGE_CURSOR: 'x-message-cursor',
    X_ITEM_CURSOR: 'x-item-cursor',
    X_ITEMS_FOUND: 'x-items-found',
    X_ITEMS_MAX: 'x-items-max'
};

export const HTTP_STATUS = {
    OK: 200,
    SEE_OTHER: 303,
    NOT_MODIFIED: 304,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    PAYMENT_REQUIRED: 402,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    DATA_MODEL_INVALID: 420,
    RETRY_LATER: 422
};

export const LOCAL_STORAGE = {
    LANGUAGE_KEY: 'languageKey',
    LANGUAGE_MAP_KEY: 'translationsMap_',
    LANGUAGE_TAG_KEY: 'translationsTag_',
    DISABLE_DELETE_CONFIRMATION: 'disableDeleteConfirmation-',
    SHOW_REVIEW_KEY: 'onlineCatalog.showReviewPanel',
    MEDIA_ASSET_ATTRIBUTE_FILTERS: 'MediaAssetAttributeFilter',
    ASSET_LIBRARY_VIEW_MODE: 'assets.libraryViewMode'
};

export const MIME_TYPES = {
    APPLICATION_GZIP: 'application/gzip',
    APPLICATION_JSON: 'application/json',
    APPLICATION_MS_EXCEL: 'application/vnd.ms-excel',
    APPLICATION_MS_POWERPOINT: 'application/vnd.ms-powerpoint',
    APPLICATION_MS_WORD: 'application/msword',
    APPLICATION_PDF: 'application/pdf',
    APPLICATION_VND_EXCEL_SHEET: 'application/vnd.ms-excel.sheet.macroenabled',
    APPLICATION_VND_EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    APPLICATION_VND_POWERPOINT: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    APPLICATION_VND_RAR: 'application/vnd.rar',
    APPLICATION_VND_WORD: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    APPLICATION_ZIP: 'application/zip',
    IMAGE_BMP: 'image/bmp',
    IMAGE_GIF: 'image/gif',
    IMAGE_JPEG: 'image/jpeg',
    IMAGE_PNG: 'image/png',
    IMAGE_SVG: 'image/svg+xml',
    IMAGE_WEBP: 'image/webp',
    TEXT_CSV: 'text/csv',
    TEXT_PLAIN: 'text/plain',
};

export const MEDIA_TYPE_ONLINE_CATALOG = {
    IMAGE: 'IMAGE',
    DOCUMENT: 'DOCUMENT'
};

export const HEADING_LEVELS = [
    { value: '2', label: 'H2' },
    { value: '3', label: 'H3' },
    { value: '4', label: 'H4' },
    { value: '5', label: 'H5' },
    { value: '6', label: 'H6' },
];
export const FONT_SIZE = ['12','14','16','18', '20', '22','24','32'];

export const heroIconSizes = {
    '3xs': 'tw-h-2 tw-w-2',
    '2xs': 'tw-h-3 tw-w-3',
    'xs': 'tw-h-4 tw-w-4',
    'sm': 'tw-h-5 tw-w-5',
    'md': 'tw-h-6 tw-w-6',
    'lg': 'tw-h-6 tw-w-6',
    'xl': 'tw-h-7 tw-w-7',
    '2xl': 'tw-h-8 tw-w-8',
    '3xl': 'tw-h-10 tw-w-10',
};
